// 登录接口：
export const loginUri = '/api/login/login'
// 查询用户权限接口
export const queryAuthUri = '/api/login/queryAuth'
// 获取短信接口
export const sendCodeUri = '/api/sms/sendCode'
// 校验短信接口
export const checkCodeUri = '/api/sms/checkCode'
// 获取微信公众号签名接口：
export const getSignatureUri = '/api/Wechat/getSignature'
// 职位推荐(小蛙推荐)根据code获取列表接口：短信邮件链接
export const getlistByCodeUri = '/api/jobRecommend/getlistByCode'
// 查询职位详情接口：
export const getJobDetailUri =
  '/hewaCorePosition/pc/positionQuery/getPositionDetail'
// 收藏接口：
export const setCollectionUri = '/api/JobCollection/setCollection'
// 职位分享生成二维码（扫码一键分享）
export const createCodeUri = '/api/jobShare/createCode'
// 职位推荐(小蛙推荐)/历史推荐列表接口 (登录后查看更多--底部登录)
export const jobRecommendIndexUri = '/api/jobRecommend/index'
// 职位分享列表接口 --后台链接出来
export const jobShareIndexUri =
  '/hewaCorePosition/pc/positionRecommend/getJobShareList'
// 获取用户协议
export const getTemplateListUri = '/api/template/getTemplateList'

//更新候选人订单进度
// export const changeStatusUri = '/api/CandidateOrders/changeStatus' //老版本的
export const changeStatusUri = '/api/CandidateOrders/crossNodeChangeStatus' //新版本
//查看并筛选
export const candidateOrdersViewUri = '/api/candidate_orders/view'
//查看当前职位详情
export const handleRecommndUri = '/api/QuickResumeProcessing/handleRecommend'
//微信处理简历列表
export const handleRecommendListUri =
  '/api/QuickResumeProcessing/handleRecommendList'

//代运营职位确认列表
export const agentJobUrl = '/api/JobContract/list'
//确认
export const agentSourUrl = '/api/JobContract/confirm'
//收藏记录
export const collectionListUri =
  '/hewaCoreUser/pc/userBehavior/listJobCollectRecord'
//历史记录
export const historyJobUri = '/hewaCoreUser/pc/userBehavior/listJobViewRecord'
//个人信息
export const userInfoUri = '/api/user/userInfo'
//登退
export const autoLogoutUri = '/api/login/autoLogout'
//获取openId
export const getOpenidUri = '/api/wechat/getOpenid'
// openId登陆
export const getOpenIdLoginUri = '/api/wechat/openidLogin'
//退出登录
export const logoutUri = '/api/login/logout'
//用户绑定或注册接口
export const loginOrRegUri = '/api/wechat/loginOrReg'
//工作台
export const workbenchUri = '/api/wechat/workbench'

// 接单
export const createPositionContractUri = '/hewaCoreReceiveOrder/receive'
// 是否是医脉职位
export const REQUEST_IS_SYBCYIMAI = "/hewaCorePosition/pc/yimai/isSyncYimai"
// 获取当前佣金规则凭证
export const positionContractOfficial = '/api/PositionContract/official'

// 候选人列表
export const documentListUri = '/hewaCoreDocument/document/getDocumentList'
// 候选人置顶
export const docTopUri = '/api/CandidateInfo/top'
// 候选人去重
export const recommendDistinctUri = '/api/CandidateInfo/RecommendDistinct'
// 获取当前接单信息
export const positionContractUri = '/api/CandidateInfo/positionContract'
// 推荐
export const createOrderUri = '/api/CandidateOrders/createOrder'
// 查询职位下的必问问题
export const getMustAskQuestionListUri =
  '/api/CandidateOrders/getMustAskQuestionList'
// 设置必问问题
export const addMustAskQuestionUri = '/api/CandidateOrders/addMustAskQuestion'
// 候选人详情
export const candidateInfoUri = '/hewaCoreDocument/document/getDocumentInfo'
// 接单列表
export const orderListUri = '/hewaCoreReceiveOrder/pc/myReceivePositionList'
// 候选人动态

export const documentPurposeUri = '/api/DocumentPurpose/dynamicList'
// 职能匹配
export const matchingListUri = '/api/JobList/getMatchingList'

// 候选人沟通通过记录
export const orderTalkUri = '/api/recommendRecord/listRecord'
// 候选人订单详情
export const orderDetailUri = '/api/CandidateOrders/orderDetail'
// 候选人必问问题
export const questionListUri = '/api/CandidateOrders/getQuestionList'
// 推荐报告
export const jReportInfoUri = '/api/CandidateOrders/getJReportInfo'
// 催一下
export const replaceOfferUri = '/api/urge/clickHurryUp'
// 候选人列表
export const candidateListUri = '/api/QuickResumeProcessing/getDocumentsByJob'

// 聊一下信息
export const cardInfoUri = '/api/im/getCardInfo'
// 发送聊一下
export const sendMsgUri = '/api/im/sendMsg'
// 下载简历
export const downloadFileUri = '/api/CandidateInfo/downloadFile'

// 获取首页banner图列表
export const getLoginImagesList = '/api/GraphicConfig/getFirstBannerList'

// 获取全部曝光位列表
export const getExposureAllList = '/api/Exposure/getExposureAllList'

// 获取h5全部曝光位列表
export const getExposureH5AllList = '/api/Exposure/getExposureH5AllList'

// 职位宣讲会列表
export const getJobPresentationList =
  '/api/jobPresentation/getJobPresentationList'

// 参加职位宣讲会
export const joinJobPresentation = '/api/jobPresentation/joinJobPresentation'

// 获取隐私号
export const privacyNumberUri = '/api/PrivacyNumber/getPrivacyNumber'

// 一件推人
export const recommendUri = 'api/CandidateInfo/recommend'
// 获取分享内容
export const jobShareParameterUri =
  '/hewaCorePosition/pc/positionRecommend/getJobShareHardInfo'

//获取候选人订单中止原因
export const getReasonInfoUri = '/api/CandidateOrders/getReasonInfo'

// 活动参数跳转
export const getActivityUrl = '/api/Activity/getActivityUrl'
// ------------------------------猎企入住----------
// 查询猎企（绑定猎企时使用）
export const consultantCompanyUrl = '/api/ConsCompany/getConsultantCompany'
// 天眼查查询公司注册信息（创建新客户）
export const searchCompanyUrl =
  '/api/CustomerCompany/searchConsultantCompanyName'
// 擅长方向标签
export const goodAtDirectionUrl = '/api/user/getGoodAtDirection'
// 获取邮箱验证码
export const getEmailCodeUrl = '/api/user/getEmailCode'
// 绑定猎企
export const bindConsultantCompanyUrl = '/api/ConsCompany/bindConsultantCompany'
// 文件上传
export const uploadUrl = '/api/files/upload'
// 营业执照上传
export const uploadBusinessLicense = '/api/ObsUpload/uploadBusinessLicense'

// 猎企信息校验
export const companyInfoVerifyUrl = '/api/ConsCompany/companyInfoVerify'
// 获取完善信息页面回显数据
export const companyInfoRedisplayUrl =
  '/api/ConsCompany/getCompanyInfoRedisplay'
// 获取企业认证链接
export const companyCertificationLinkUrl =
  '/api/ContractLock/getCompanyCertificationLink'
// 获取企业认证结果
export const companyAuthStatusUrl = '/api/ContractLock/getCompanyAuthStatus'
// 禾蛙企业授权链接---------------
export const companyAuthorizationLinkUrl =
  '/api/ContractLock/getCompanyAuthorizationLink'
// 禾蛙企业授权信息---------------
export const companyAuthorizationInformationUrl =
  '/api/ContractLock/getCompanyAuthorizationInformation'
// 法人验证---------------
export const legalPersonAuthUrl = '/api/ContractLock/legalPersonAuth'
// 获取签署合同链接---------------
export const contractLinkUrl = '/api/ContractLock/getContractLink'
// 获取合同签署结果---------------
export const contractSignStatusUrl = '/api/ContractLock/getContractSignStatus'
// 放弃注册---------------
export const abandonRegisterUrl = '/api/ConsCompany/abandonRegister'
// 获取顾问信息---------------
export const userDetailUrl = '/api/User/getUserDetail'
// 获取企业认证授权结果---------------
export const companyAuthorizationStatusUrl =
  '/api/ContractLock/getCompanyAuthorizationStatus'
// 实名认证---------------
export const authenticationUrl = '/api/user/authentication'
// 实名认证状态查询---------------
export const authenticationStatusUrl = '/api/user/getAuthenticationStatus'
// 自动加入契约锁
export const addUsreToQiyuesuoUri = '/api/user/addUsreToQiyuesuo'
// 验证猎企状态接口---------------
export const checkCompanyAuth = '/api/ConsCompany/checkCompanyAuth'

// 检测用户是否有资格参与活动
export const checkUserJoinSatisfactionUri =
  '/api/satisfaction/checkUserJoinSatisfaction'
// 获取满意度标签列表
export const satisfactionLableListUri =
  '/api/satisfaction/getSatisfactionLableList'
// 提交意见反馈\下次再说接口
export const submitAndCancelUri = '/api/satisfaction/submitAndCancel'

//  职位列表
export const meragejobList =
  '/hewaCorePosition/pc/positionSearch/queryPositionList'

// 用人单位信息查询
export const getCompanyDetailUri = '/api/JobDetail/getCompanyDetail'

// 浏览行为上报
export const addJobViewRecordUri =
  '/hewaCoreUser/pc/userBehavior/addJobViewRecord'

// 行为数据上报
export const setBehavioralDataUri = '/api/job/setBehavioralData'

/**
 * @人才广场授权流程
 * @linkInfo 获取授权链接信息
 * @authCode 授权短信验证码
 * @validCode 校验短信验证码
 * @protocol 生成授权书
 * @authAgree 同意授权
 * @authRefuse 拒绝授权
 * @authInfoInvalid 已失效查询授权记录
 * @authInfoValid 未失效查询授权记录
 * @cancelAuth 取消授权H5
 * @authInvalidCode 已失效发送短信验证码
 * @authInvalidCodeCheck 校验已失效发送短信验证码
 */
export const linkInfo = '/hewaCoreDocument/h5/square/sms/link/info'
export const authCode = '/hewaCoreDocument/h5/square/sms/code'
export const validCode = '/hewaCoreDocument/h5/square/sms/valid'
export const protocol = '/hewaCoreDocument/h5/square/auth/protocol'
export const authAgree = '/hewaCoreDocument/h5/square/auth/agree'
export const authRefuse = '/hewaCoreDocument/h5/square/auth/refuse'
export const authInfoInvalid = '/hewaCoreDocument/h5/square/invalid/auth/info'
export const authInfoValid = '/hewaCoreDocument/h5/square/auth/info'
export const cancelAuth = '/hewaCoreDocument/h5/square/cancelAuth'
export const authInvalidCode = '/hewaCoreDocument/h5/square/expire/sms/code'
export const authInvalidCodeCheck =
  '/hewaCoreDocument/h5/square/expire/sms/valid'
// 账单详情接口
export const getBilDetailUri = '/api/Bill/getBilDetail'
// 确认账单
export const billConfirmUri = '/api/Bill/billConfirm'

export const getAccountInfoUri = '/api/CorporateAccount/getAccountInfo'
export const getRefundContractLinkUri = '/api/Bill/getRefundContractLink'

// 擅长行业
export const queryIndustryInfo = '/hewaCoreDictionary/industry/industryInfo'

// 信息采集提交接口
export const recruitmentInfoCollectUri =
  '/hewaCoreHomePage/recruitmentInfoCollect'

// 信息采集发送验证码接口
export const recruitmentInfoSendCodeUri =
  '/hewaCoreHomePage/recruitmentInfoSendCode'

// 获取附件简历
export const getDocumentFileInfoUri =
  '/hewaCoreDocument/document/getDocumentFileInfo'

//已收藏职位列表
export const queryCollectedPositionList =
  '/hewaCorePosition/pc/positionCollection/queryCollectedPositionList'
/**
 * H5未登录全部职位列表
 * https://showdoc.hewa.cn/web/#/16/3994
 */
export const QUERY_NO_LOGIN_POSITION_LIST =
  '/hewaCorePosition/pc/positionSearch/queryNoLoginPositionList'
/**
 * 人才广场列表
 * https://showdoc.hewa.cn/web/#/16/4034
 */
export const SAP_LIST_URL = '/hewaCoreDocument/h5/square/talent/sapList'
/**
 * 人才广场候选人详情
 */
export const TALENT_DETAIL_URL = '/hewaCoreDocument/h5/square/detail'
/**
 * 人才报名-发送验证码
 * https://showdoc.hewa.cn/web/#/16/4026
 */
export const TALENT_SEND_SMS_CODE_URL =
  '/hewaCoreDocument/h5/square/sendSmsCode'

/**
 * 人才报名-报名
 * https://showdoc.hewa.cn/web/#/16/4021
 */
export const TALENT_ENROLL_URL = '/hewaCoreDocument/h5/square/enroll'
/**
 * 人才报名-顾问信息
 * https://showdoc.hewa.cn/web/#/16/4023
 */
export const TALENT_INVITE_USER_INFO_URL =
  '/hewaCoreDocument/h5/square/getInviteUserInfo'

/**
 * 人才报名-行业/城市配置
 */
export const SQUARE_CONFIG_URL = '/hewaCoreDocument/h5/square/getConfig'

/**
 * sap意向提交
 * https://showdoc.hewa.cn/web/#/16/4024
 */
export const SUB_MISSION_HUB_URL = '/hewaCoreDocument/h5/square/submissionHub'

/**
 * 职能信息
 */
export const GET_FUNCTION_INFO_URL =
  '/hewaCoreDictionary/function/getFunctionInfo'
/**
 * 城市信息
 */
export const GET_CITY_LIST_URI = '/api/city/index'

//获取发单顾问信息
export const getUserInfoByJobId =
  '/hewaCoreUser/miniProgram/userInfo/getUserInfoByJobId'

// 邮箱提交
export const checkEmailCode = '/api/user/checkEmailCode'

// 换取obs地址
export const GET_OBS_URL = '/hewaCoreCandidateRecommend/getUrl'

// 判断是否禁止推人
export const isStopRecommend = '/hewaCoreCandidateRecommend/isStopRecommend'

// 实名 姓名身份证号
export const realNameIdentify = '/hewaCoreUser/user/realNameIdentify'

// 职位包统计接口
export const jobPackageStatisticsUri =
  '/hewaCorePosition/pc/positionRecommend/jobPackageStatistics'

/*-------------------------猎企入驻相关开始---------------------------- */
// 擅长业务类型
export const getBusinessTypeUri = '/api/PersonCenter/getBusinessType'
// 擅长职能
export const getPersonalCenterFunctionInfoUri =
  '/hewaCoreDictionary/function/getPersonalCenterFunctionInfo'
// 擅长行业
export const industryInfoUri = '/hewaCoreDictionary/industry/industryInfo'

/*-------------------------猎企入驻相关结束---------------------------- */
